export const appLinkConfig = {
  iosDeepLink: process.env.REACT_APP_MARLTA_IOS_DEEP_LINK || 'malta://intro',
  androidDeepLink: process.env.REACT_APP_MARLTA_ANDROID_DEEP_LINK || 'malta://intro',
  androidPackageName: process.env.REACT_APP_MARLTA_ANDROID_PACKAGE || 'com.timehive.marlta',
  iosStoreUrl: process.env.REACT_APP_MARLTA_IOS_STORE_URL || 'https://apps.apple.com/app/id1532007829',
  androidStoreUrl:
    process.env.REACT_APP_MARLTA_ANDROID_STORE_URL ||
    'https://play.google.com/store/apps/details?id=com.timehive.marlta',
  fallbackDelayMs: 1600,
};
